// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_f6-0";
export var fileCarousel = "_f6-2";
export var removeFileButton = "_f6-1";